import ActivationMessage, {ActivationMessageProps, ActivationMessageType} from "./ActivationMessage";

interface ActivationErrorProps extends Omit<ActivationMessageProps, "type"> {
  type?: ActivationMessageType;
}

export default function ActivationError(props: ActivationErrorProps) {
  return (
    <ActivationMessage
      {...props}
      type={ActivationMessageType.ERROR}
    />
  );
}